import { NAVIGATION_CHANGING, NAVIGATION_CHANGED } from "./actions";

export const navigationChanging = (newUrl: string, originalUrl: string) => ({ type: NAVIGATION_CHANGING, payload: { newUrl, originalUrl } })
export const navigationChanged = (newUrl: string) => ({ type: NAVIGATION_CHANGED, payload: { newUrl } })


// WEBPACK FOOTER //
// ./src/store/modules/navigation/actionCreators.ts